import OPE from 'js/on-page-editing';

import Link from 'components/link/Link';

import { INumberBlock } from 'source/NFR.types';

const NumberBlock: React.FC<INumberBlock> = ({ description, number, onPageEditing, text, url, link }) => (
  <div className="number-block">
    <div {...OPE(onPageEditing?.url)} />
    {link && (
      <span className="has-action-link" {...OPE(onPageEditing?.text)}>
        <Link theme="actionLink" url={link.url}>
          {link.text && <h2>{link.text}</h2>}
        </Link>
      </span>
    )}
    <span {...OPE(onPageEditing?.text)}>
      <Link url={url}>{text && <h2>{text}</h2>}</Link>
    </span>
    <div className="number-block--number-wrapper">
      <span className="number-block--number" {...OPE(onPageEditing?.number)}>
        {number}
      </span>
      <span className="number-block--description" {...OPE(onPageEditing?.description)}>
        {description}
      </span>
    </div>
  </div>
);

NumberBlock.displayName = 'NumberBlock';

export default NumberBlock;
